const selectricInits = () => {
    $('.js__selectric').selectric();
};